/*
 * @Author: caiqin.xie
 * @since: 2023-06-19 14:52:38
 * @lastTime: 2023-11-24 17:10:34
 * @LastEditors: caiqin.xie
 * @message: 保修查询
 * @url: www.picoxr.com/cn/support/activate-benefits
 */
import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { Message, Button } from '@arco-design/web-react';
import Header from "@/components/Header/index";
import Footer from "@/components/Footer/index";
import Banner from "./components/Banner";
import Notes from "./components/Notes";
import QueryResult from "./components/QueryResult";
import styles from "./index.module.scss";
import request from '@/common/request'
import { DOMAIN_API, BENEFITSPOS, COUNTRY_LIST, COUNTRY_HREFLANG } from '@/common/const'
import classNames from "classnames";

const ActivateBenefits = (props: any) => {
  const {ctry, words, data} = props.data
  const [dialogVisible, setDialogVisible] = useState<boolean>(false); // 搜素结果弹窗
  const [verificationCode, setVerificationCode] = useState<Record<string, any>>(data) // 后台获取验证码数据
  const [snInfo, setSnInfo] = useState<Record<string, any>>(null) // 后台获取权益信息
  const [snNumber, setSnNumber] = useState<string>('') // SN码
  const [vCode, setVcode] = useState<string>('') // 验证码
  const bannerList = data?.bannerPageVos || null // banner列表
  const [captchaId, setCaptchaId] = useState<string>(data?.captchaId || '') // 验证码id

  // 搜索权益
  const searchBenefits = () => {
    console.log(snNumber)
    if (!snNumber) {
      Message.error(words?.support_benefit_validate_device_SN)
      // 请输入SN码
      return false
    }
    // if (!vCode) {
    //   Message.error(words?.support_benefit_validate_enter_code)
    //   // 请输入验证码
    //   return false
    // }
    request.post(`${DOMAIN_API}/o/equityAllocation/select`, {stationCode: ctry, sn: snNumber, code: vCode, captchaId})
    .then(res => {
      setSnInfo(res.data)
      changeDialogVisible(!dialogVisible)
      resetVerificationCode()
    })
    .catch(err => {
      Message.error(words[err?.data?.messageInfo] || err.msg)
      changeVerificationCode()
      console.log(err)
    })
  }

  // 重置表单数据
  function resetVerificationCode () {
    setVcode('')
    changeVerificationCode()
  }

  // 权益结果弹框
  const changeDialogVisible = (visible: boolean) => {
    setDialogVisible(visible)
  }

  // 刷新验证码
  function changeVerificationCode () {
    request.get(`${DOMAIN_API}/o/equityAllocation/getCaptcha?captchaId=${captchaId}`)
    .then(res => {
      setVerificationCode(res.data)
      setCaptchaId(res.data?.captchaId)
    })
    .catch(err => {
      console.log(err)
    })
  }

  // 生成hreflang
  const renderHrefLang = () => {
    return (
      COUNTRY_LIST.map(item => (
        <link key={item} rel="alternate" hrefLang={COUNTRY_HREFLANG[item]} href={`${DOMAIN_API}/${item}/support/activate-benefits`} />
      ))
    )
  }

  return (
    <>
      <Helmet>
        <title>{words?.support_benefit_seo_title}</title>
        <meta name="description" content={words?.support_benefit_seo_description} />
        <meta name="keywords" content={words?.support_benefit_seo_keywords} />
        <link rel="canonical" href={`${DOMAIN_API}/${ctry}/support/activate-benefits`} />
        {renderHrefLang()}
      </Helmet>
      <Header ctry={ctry} words={words}/>
      <main className={styles['support-wrap']}>
        {/* banner区 */}
        <Banner ctry={ctry} words={words} banner={bannerList && bannerList[0]} />
        {/* 内容区 */}
        <section className={styles["content-wrap"]}>
          {/* <h2>Activation and Benefit Information Query</h2> */}
          <form className={styles["form"]}>
            <div className={styles["form-item"]}>
              <input
                type="text" placeholder={words?.support_benefit_enter_device_SN}
                value={snNumber} onChange={(e) => setSnNumber(e.target.value)} />
              {/* Enter device SN */}
              <a className={styles["form-tips"]} href={`/${ctry}/support/faq`}>
                {words?.support_benefit_view_device_SN}
                {/* How to view the device serial number */}
              </a>
            </div>
            <div className={styles["form-item"]}>
              <input
                type="text" placeholder={words?.support_benefit_enter_code}
                value={vCode} onChange={(e) => setVcode(e.target.value)} />
              {/* Enter Code */}
              <p className={styles["verification-code"]} onClick={changeVerificationCode}>
                <img src={`data:image/png;base64,${verificationCode?.codeImg}`} alt="" />
              </p>
            </div>
            <div className={styles["search-btn"]}>
              <Button
                size="large"
                className={classNames(styles["btn"], {
                  [styles["btn-disabled"]]: !snNumber || !vCode
                })}
                onClick={searchBenefits}
                disabled={!snNumber || !vCode}>
                {words?.common_search}
                {/* Search */}
              </Button>
            </div>
          </form>
          <Notes ctry={ctry} words={words} />
        </section>
        {/* 查询信息弹框 */}
        <QueryResult
          changeDialogVisible={changeDialogVisible}
          ctry={ctry}
          words={words}
          snInfo={snInfo}
          dialogVisible={dialogVisible} />
      </main>
      <Footer />
    </>
  );
};

function getInit(ctry: string) {
  return new Promise((resolve, reject) => {
    request.get(`${DOMAIN_API}/o/equityAllocation/get?bannerPositionId=${BENEFITSPOS}&stationCode=${ctry}`)
    .then(res => {
      resolve(res.data)
    })
    .catch(err => {
      reject(err)
    })
  });
}

ActivateBenefits.getInitialProps = (ctry: string) => {
  return getInit(ctry)
};
export default ActivateBenefits;


